import { call, put } from 'redux-saga/effects';
import { requestRoles, requestRole, requestRoleExpandedPermissions, requestRoleUsers, requestCreateRole, requestUpdateRole, requestDeleteRole } from '../requests/role';
import { showAlert } from '../../slices/alerts';
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetRoles(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestRoles);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetRole(action) {
    try {
        const { roleId, callback } = action.payload;
        const response = yield call(requestRole, roleId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetRoleExpandedPermissions(action) {
    try {
        const { roleId, callback } = action.payload;
        const response = yield call(requestRoleExpandedPermissions, roleId);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        if (action.payload?.callback) action.payload.callback(null);
    }
}

export function* handleGetRoleUsers(action) {
    const { roleId, params, callback } = action.payload;
    try {
        const response = yield call(requestRoleUsers, roleId, params);
        if (callback) callback(response.data);
    } catch (error) {
        if (callback) callback(null);
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleCreateRole(action) {
    try {
        const { roleData, callback } = action.payload;
        const response = yield call(requestCreateRole, roleData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleUpdateRole(action) {
    try {
        const { roleId, roleData, callback } = action.payload;
        const response = yield call(requestUpdateRole, roleId, roleData);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleDeleteRole(action) {
    const { roleId, migrateTo, callback } = action.payload;
    try {
        const response = yield call(requestDeleteRole, roleId, migrateTo);
        if (callback) callback(response.data, null);
    } catch (error) {
        // 409 with userCount = caller needs to prompt for migrateTo. Bubble the shape up
        // via the callback rather than firing a generic alert, so the page can branch.
        const status = error?.response?.status;
        const data = error?.response?.data;
        if (callback) callback(null, { status, ...data });
        if (status !== 409) {
            yield put(showAlert({ severity: 'error', message: data?.message || error?.message || 'Failed to delete role' }));
        }
    }
}
